// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","750": "mercury-tokens",}[chunkId] || chunkId) + "-" + {"545": "e26e077b423097ac","75": "5a5560deccaec052","750": "d475b2b645787f2a",}[chunkId] + ".css"
}